/* DillySocks — Bewertungs-Karussell (sections/ds-reviews.liquid).

   Verdrahtet die im Liquid gerenderten Pfeile mit der Scroll-Snap-Row.
   Gleiche robuste Scroll-Logik wie das Icon-Karussell: Ziel = naechster
   Snap-Punkt, smooth via CSS-Property mit hartem Fallback (greift, wenn
   Animationen unterdrueckt werden, z. B. in Hintergrund-Tabs), Pfeil-
   Zustaende werden nach jedem Klick explizit nachgefuehrt. */
(function () {
  'use strict';

  function setup(root) {
    (root || document).querySelectorAll('[data-ds-reviews]').forEach(function (sec) {
      if (sec.dataset.dsRevInit === '1') return;
      var row = sec.querySelector('[data-ds-rev-row]');
      var prev = sec.querySelector('[data-ds-rev-prev]');
      var next = sec.querySelector('[data-ds-rev-next]');
      var stage = sec.querySelector('.ds-reviews__stage');
      if (!row || !prev || !next || row.children.length === 0) return;
      sec.dataset.dsRevInit = '1';

      function step() {
        if (row.children.length < 2) return row.clientWidth;
        return row.children[1].offsetLeft - row.children[0].offsetLeft;
      }

      function update() {
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 4) {
          stage.setAttribute('data-static', '');
        } else {
          stage.removeAttribute('data-static');
        }
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max - 2;
      }

      function go(dir) {
        var s = step();
        var max = row.scrollWidth - row.clientWidth;
        var idx = Math.round(row.scrollLeft / s) + dir;
        var target = Math.max(0, Math.min(max, idx * s));
        row.style.scrollBehavior = 'smooth';
        row.scrollLeft = target;
        setTimeout(function () {
          if (Math.abs(row.scrollLeft - target) > 2) {
            row.style.scrollBehavior = 'auto';
            row.scrollLeft = target;
          }
          row.style.scrollBehavior = '';
          update();
        }, 450);
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
